import * as clientErrTypes from 'config/clientErrorTypes';
import { isErrMemberPointsNotEnough } from 'client/utils/errorObjectChecker';

/**
 * 檢查錯誤是否為點數被上鎖錯誤
 * @typedef {Function} CHECK_POINT_IS_LOCKED
 * processing - 1 => 檢查鎖時發現有鎖噴錯
 * processing - 2 => 上鎖時，如果有鎖就會噴錯
 */
export const CHECK_POINT_IS_LOCKED = resp =>
    resp.httpStatus === 400 &&
    resp?.payload?.code === 'PSM-V0-F0' &&
    (resp?.payload?.message === 'Data processing - 1' ||
        resp?.payload?.message === 'Data processing - 2');

export const REDEEM_POINT_API_RESPONSE = {
    [clientErrTypes.POINT_IS_LOCKED]: CHECK_POINT_IS_LOCKED,
    // 餘額不足統一由 isErrMemberPointsNotEnough 判斷，同時涵蓋本系統 (PSM) 與 uTagGo (A6101) 兩種結構
    [clientErrTypes.REDEEM_POINT_IS_NOT_ENOUGH]: r => isErrMemberPointsNotEnough(r),
    [clientErrTypes.REDEEM_POINT_FAILED]: r => r.httpStatus !== 200
};

export const GET_MEMBER_POINT_TOTAL_BY_MEMBER_API_RESPONSE = {
    [clientErrTypes.GET_MEMBER_POINT_FAILED]: r => r.httpStatus !== 200
};
